import { render, staticRenderFns } from "./NonNormalizedAccounts.vue?vue&type=template&id=c223e10c"
import script from "./NonNormalizedAccounts.vue?vue&type=script&lang=ts"
export * from "./NonNormalizedAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports